import NetworkSettings from './NetworkSettings'

export default NetworkSettings
